<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2">Notifiche</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox
                                color="primary"
                                hide-details
                                v-model="settings['notify_expiring_project']">
                            </v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Scadenza Progetto</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando un Progetto sta per scadere
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-slide-y-transition>
                    <v-list two-line subheader class="background-2 px-2 pb-2 pt-0" v-if="settings['notify_expiring_project']">
                        <v-list-item>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content style="height: 90px; padding-top: 24px;">
                                <v-text-field v-if="settings['notify_expiring_project']"
                                    label="Numero giorni prima"
                                    v-model="settings['notify_expiring_project_day_before']"
                                    type="number"
                                    required
                                    outlined
                                    dense
                                    :error-messages="errors.collect('daybefore1')"
                                    v-validate="'required'"
                                    data-vv-name="daybefore1"
                                    data-vv-as="Numero giorni prima"
                                ></v-text-field>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-slide-y-transition>

                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['notify_expired_project']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Progetto Scaduto</v-list-item-title>
                            <v-list-item-subtitle>Ricevi una notifica quando un Progetto è scaduto
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="mx-4 my-0" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>

            <!-- Causali con cui la scheda Commessa crea consumi, rientri e costi commessa -->
            <v-card class="flex pa-0 mt-3 background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 mb-0">Causali commessa</p>
                    <v-spacer></v-spacer>
                    <v-btn small outlined color="primary" :loading="creatingCausals" @click="createCommissionCausals">
                        <v-icon left small>mdi-plus</v-icon>
                        Crea causali commessa
                    </v-btn>
                </v-card-title>
                <v-card-subtitle class="px-5 pt-1 pb-0">
                    Causali dei DDT usate dal pulsante "Nuovo costo" della scheda Commessa. Ogni elenco mostra solo le causali
                    con il comportamento giusto; il pulsante crea quelle predefinite che mancano e le seleziona.
                </v-card-subtitle>
                <v-divider class="mt-3"></v-divider>
                <v-list two-line subheader class="background-2 pa-2">
                    <v-list-item v-for="role in commissionRoles" :key="role.role">
                        <v-list-item-content>
                            <v-list-item-title>{{ role.label }}</v-list-item-title>
                            <v-list-item-subtitle>{{ role.hint }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="commission-causal-select">
                            <v-select
                                v-model="settings[role.key]"
                                :items="role.options"
                                item-value="value"
                                item-text="text"
                                :placeholder="role.options.length ? 'Nessuna causale' : 'Nessuna causale adatta'"
                                :disabled="!role.options.length"
                                outlined
                                dense
                                hide-details
                                clearable>
                            </v-select>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="mx-4 my-0" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Vue from 'vue'
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin';

    // Ruoli dei documenti creabili dalla commessa: le opzioni e la chiave dell'impostazione arrivano dal BE
    const COMMISSION_ROLES = {
        consumption: { label: 'Consumo commessa', hint: 'DDT di vendita non fatturabile che scarica il materiale montato senza DDT al cliente' },
        consumption_return: { label: 'Rientro da commessa', hint: 'DDT di vendita non fatturabile che ricarica il materiale tornato dal cantiere' },
        project_cost: { label: 'Costo commessa', hint: 'DDT di acquisto senza movimento per noleggi, alberghi e altri costi senza merce' },
    }

    export default {
        name: 'projects-options',
		mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'project',
                settings: {
                    'notify_expiring_project': false,
                    'notify_expiring_project_day_before': false,
                    'notify_expired_project': false,
                    'commission_consumption_causal': null,
                    'commission_return_causal': null,
                    'commission_cost_causal': null,
                },
                commissionRoles: [],
                creatingCausals: false,
            }
        },

        watch: {
            settings: {
                handler() {
                    if(!this.settings['notify_expiring_project']) {
                        Vue.set(this.settings, 'notify_expiring_project_day_before', null)
                    }
                },
                deep: true,
            }
        },

        methods: {
            // Opzioni per ruolo; il valore configurato lo mette nelle impostazioni, cosi' il Salva lo riporta al BE
            applyCommissionCausals(data) {
                this.commissionRoles = (data.roles || []).map(role => ({ ...role, ...(COMMISSION_ROLES[role.role] || { label: role.role, hint: '' }) }))
                this.commissionRoles.forEach(role => {
                    this.$set(this.settings, role.key, role.value || null)
                })
            },

            loadCommissionCausals() {
                this.axios.get('project-commission-causals').then(response => {
                    this.applyCommissionCausals(response.data.data || {})
                }, () => {})
            },

            createCommissionCausals() {
                this.creatingCausals = true
                this.axios.post('project-commission-causals').then(response => {
                    this.applyCommissionCausals(response.data.data || {})
                    this.$store.commit('setSnackbar', { timeout: 6000, text: 'Causali commessa pronte', value: true, color: 'success' })
                }, () => {
                    this.$store.commit('setSnackbarError')
                }).finally(() => {
                    this.creatingCausals = false
                })
            },
        },

        created() {
            this.loadCommissionCausals()
        },
    }
</script>

<style scoped>
.commission-causal-select {
    min-width: 260px;
}
</style>